import Icon from "@Components/generic/icon";
import { getMetricPrimaryColor, getMetricSecondaryColor } from "@Containers/app/stat-cards/tooltips/get-metric-colors";
import getMetricIcon from "@Containers/app/stat-cards/tooltips/get-metric-icon";
import MetricEventTypes from "@Enums/MetricEventTypes";
import MetricFilterTypes from "@Enums/MetricFilterTypes";
import { faChartBar, IconDefinition } from "@fortawesome/pro-solid-svg-icons";
import { Box, useTheme } from "@mui/material";

const MetricTypeIcon = ({ metricType, size = 6 }: { metricType: MetricEventTypes | MetricFilterTypes; size?: number }) => {
  const theme = useTheme();
  let icon: IconDefinition = faChartBar;
  let iconColor: string = theme.palette.dsPrimary.v200;
  let bgColor: string = theme.palette.dsPrimary.v100;

  switch (metricType) {
    case MetricEventTypes.SCAN_FREQUENCY:
      icon = getMetricIcon(metricType);
      iconColor = getMetricPrimaryColor(metricType, theme);
      bgColor = getMetricSecondaryColor(metricType, theme);
      break;
    case MetricEventTypes.AWARENESS:
      icon = getMetricIcon(metricType);
      iconColor = getMetricPrimaryColor(metricType, theme);
      bgColor = getMetricSecondaryColor(metricType, theme);
      break;
    case MetricEventTypes.SCAN_TIMING:
      icon = getMetricIcon(metricType);
      iconColor = getMetricPrimaryColor(metricType, theme);
      bgColor = getMetricSecondaryColor(metricType, theme);
      break;
    case MetricEventTypes.CRITICAL_SCAN:
      icon = getMetricIcon(metricType);
      iconColor = getMetricPrimaryColor(metricType, theme);
      bgColor = getMetricSecondaryColor(metricType, theme);
      break;
    case MetricEventTypes.DECISION:
      icon = getMetricIcon(metricType);
      iconColor = getMetricPrimaryColor(metricType, theme);
      bgColor = getMetricSecondaryColor(metricType, theme);
      break;
  }

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "25%",
        width: theme.spacing(size),
        height: theme.spacing(size),
        backgroundColor: bgColor,
      }}
    >
      <Icon icon={icon} color={iconColor} sx={{ display: "flex", fontSize: theme.spacing(size / 2) }} />
    </Box>
  );
};

export default MetricTypeIcon;
